import { z } from "zod";

import { creditReasonFieldsSchema } from "./credit-reason";

const AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;

export const issueCreditFormSchema = z.object({
  amount: z
    .string()
    .transform(normalizeAmount)
    .refine(
      (amount) => AMOUNT_PATTERN.test(amount) && Number(amount) > 0,
      "Enter an amount greater than zero",
    ),
  invoiceId: z.string().min(1, "Select an invoice"),
  ...creditReasonFieldsSchema,
});

export type IssueCreditFormInput = z.input<typeof issueCreditFormSchema>;

export type IssueCreditFormValues = z.output<typeof issueCreditFormSchema>;

function normalizeAmount(amount: string): string {
  return amount.replaceAll(/[\s$,]/g, "");
}
